import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { DEFAULT_REQUEST_PARAMS } from '@shared/core/types';
import { convertApiItemResponseToItem } from '@shared/core/utils';

import {
  CurrentOperator,
  OperatorStatus,
  OperatorStatusData,
  OperatorStatusDataResponse,
} from '../../core/types/operator';
import { WfmBaseApiService } from '@shared/core/services/wfm-base-api.service';

@Injectable({
  providedIn: 'root',
})
export class OperatorApiService extends WfmBaseApiService {
  updateStatus(status: OperatorStatus): Observable<void> {
    return this.api
      .post<void>(`${this.baseEndpoint}/api/working-status`, {
        params: {
          type: status,
          systemType: 'crm',
        },
        ...DEFAULT_REQUEST_PARAMS,
      })
      .pipe(catchError(() => of(null)));
  }

  getStatusInfo(): Observable<OperatorStatusData> {
    return this.api
      .get<OperatorStatusDataResponse>(`${this.baseEndpoint}/api/working-status`, {
        params: {
          systemType: 'crm',
        },
        ...DEFAULT_REQUEST_PARAMS,
      })
      .pipe(
        convertApiItemResponseToItem,
        catchError(() => of()),
      );
  }

  getCurrentOperator(): Observable<CurrentOperator> {
    return this.api
      .get<CurrentOperator>(`${this.baseEndpoint}/api/operator/current`, {
        ...DEFAULT_REQUEST_PARAMS,
      })
      .pipe(catchError(() => of()));
  }
}
